import * as d3 from 'd3';
import { AnnotationModelItem, CircleData } from '../interfaces';

export const drawCircle = function (wrapper, item: AnnotationModelItem) {
  const data: CircleData = item.data as CircleData;

  const w = d3.select(wrapper);
  const circle: d3.Selection<SVGCircleElement, unknown, null, undefined> = w.select(`#item${item.id}`).node()
    ? w.select(`#item${item.id}`)
    : w.append('circle');

  circle
    .attr('id', `item${item.id}`)
    .attr('r', data.radius || 1)
    .attr('stroke', data.color)
    .style('stroke-width', data.strokeWidth)
    .attr('fill', 'none');
  return circle;
};
